import { render, staticRenderFns } from "./NewLocation.vue?vue&type=template&id=04b3299c&"
import script from "./NewLocation.vue?vue&type=script&lang=js&"
export * from "./NewLocation.vue?vue&type=script&lang=js&"
import style0 from "./NewLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports